
import { setCiftSuruculuTahminiVaris, setTekSuruculuTahminiVaris } from "../../features/topPagesMap/topPagesMapSlice";
import store from "../../store/store"
import getFutureDateAndTime from "../date/getFutureDateAndTime";
import { roundToNearestHalfHour } from "./getTekSuruculuTahminiVaris";


//! bunlara revize gelmesi lazım tam düzgün hali için
const getCiftSuruculuTahminiVaris = (allDistance, remainingDistance, startDate) => {


    //! ilk koşul
    if(remainingDistance <= 70){

        const date = new Date()
        // Saat ekleme işlemi (5 saat ekleme)
        let hoursToAdd = remainingDistance / 70;
        date.setHours(date.getHours() + hoursToAdd + 3);

        // Yeni tarihi gösterelim

        store.dispatch(setCiftSuruculuTahminiVaris(getFutureDateAndTime(roundToNearestHalfHour(new Date(date.toISOString())))))

    }

    //! ikinci koşul
    else{
        let date = new Date(startDate);
        let dinlenmeSuresi;
        const toplamSurusSuresi = allDistance / 70

        if(toplamSurusSuresi <= 4.5){
            dinlenmeSuresi = 0
        }
        else if(toplamSurusSuresi <= 9){
            dinlenmeSuresi = 1
        }
        else if(toplamSurusSuresi <= 13.5){
            dinlenmeSuresi = 2
        }
        else if(toplamSurusSuresi <= 18){
            dinlenmeSuresi = 3
        }
        else if(toplamSurusSuresi <= 22.5 ){
            dinlenmeSuresi = 4
        }
        else if(toplamSurusSuresi <= 27){
            dinlenmeSuresi = 5
        }
        else if(toplamSurusSuresi <= 31.5 ){
            dinlenmeSuresi = 6
        }
        else{
            dinlenmeSuresi = 7
        }

        date.setHours(date.getHours() + (parseInt(toplamSurusSuresi) + dinlenmeSuresi + 3)); 
        store.dispatch(setCiftSuruculuTahminiVaris(getFutureDateAndTime(roundToNearestHalfHour(new Date(date.toISOString())))))

    }
   

}

export default getCiftSuruculuTahminiVaris